import { MantineTheme } from "@mantine/core";
import { pxToRem } from "theme";

type StepStyles = {
  theme: MantineTheme;
  currentStep: number;
  stepIndex: number;
};

export const stepStyles = ({ theme, currentStep, stepIndex }: StepStyles) => ({
  height: pxToRem[10],
  backgroundColor: currentStep >= stepIndex + 1 ? theme.other.primary[30] : theme.other.primary[5],
  width: "100%",
});
